const production = {
  env: 'production',
  backendUrl: 'https://api.letsgosurveys.com',
}
export default production
